module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }, [_c('p', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/e9781338162905_title001#tp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ded001#ded01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781338162905_ch001#ch1"
    }
  }, [_vm._v("Chapter One: Too Bad, So Sad")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781338162905_ch002#ch2"
    }
  }, [_vm._v("Chapter Two: Rain, Rain, Go Away")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: Milk and Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Ninety-Nine, One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Up All Night")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Fit for a Princess")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Having a Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Brainstorm")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Dial P for Princess")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Poster the Town")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: Another Knock at the Door")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: Are You Smarter than a Fifth Grader?")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: Alligator Snack")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch014#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: Tricks & Treats")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch015#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: And the Answer Is …")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch016#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: Overboard")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ch017#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: Human Ladder")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_bm001#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teaser")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ack001#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_ata001#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_bm002#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read all the Whatever After books!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338162905_copy001#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db58f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781338162905_toc001.vue
// module id = 63
// module chunks = 0